<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu/index';
	import { locale, locales } from '$lib/i18n';
	import { storeLocal } from '$lib/stores/storeLocal';
	import Icon from '@iconify/svelte';

	let languages = [
		{ name: 'English', code: 'en', icon: 'circle-flags:uk' },
		{ name: '简体中文', code: 'zh', icon: 'emojione:flag-for-china' },
		{ name: '繁體中文', code: 'zh-TW', icon: 'emojione:flag-for-hong-kong-sar-china' },
		{ name: '日本語', code: 'ja', icon: 'emojione:flag-for-japan' },
		{ name: 'Tiếng Việt', code: 'vi', icon: 'emojione:flag-for-vietnam' },
		{ name: 'Bahasa Melayu', code: 'ms', icon: 'emojione:flag-for-malaysia' },
		{ name: '한국어', code: 'ko', icon: 'emojione:flag-for-south-korea' },
		{ name: 'ภาษาไทย', code: 'th', icon: 'emojione:flag-for-thailand' },
		{ name: 'русский', code: 'ru', icon: 'emojione:flag-for-russia' }
		// { name: 'فارسی', code: 'fa', icon: 'emojione:flag-for-iran' },
	];

	// Initialize selectedLanguage with the current locale
	$: selectedLanguage = $locale;

	const findLang = (code: string) => {
		const foundLang = languages.find((l) => code === l.code);
		return { name: foundLang!.name, icon: foundLang!.icon };
	};

	const onChangeLanguage = (lang: string) => {
		$locale = lang;
		storeLocal.set({
			...$storeLocal,
			lang: lang
		});
	};
</script>

<div class="">
	<DropdownMenu.Root>
		<DropdownMenu.Trigger asChild let:builder>
			<Button
				builders={[builder]}
				variant="outline"
				class="border-none bg-transparent p-3 hover:bg-transparent hover:text-purple-500 md:p-5"
			>
				<Icon icon="material-symbols:language" width="1.5em" height="1.5em" />
			</Button>
		</DropdownMenu.Trigger>
		<DropdownMenu.Content class="w-[150px] border-none bg-[#251235] md:w-[180px]">
			{#each $locales as lang}
				<DropdownMenu.CheckboxItem
					checked={selectedLanguage === lang}
					onCheckedChange={() => onChangeLanguage(lang)}
					class="language-item cursor-pointer gap-x-2 text-[12px] md:text-sm"
				>
					<Icon icon={findLang(lang).icon} class="text-lg" />
					{findLang(lang).name}
				</DropdownMenu.CheckboxItem>
			{/each}
		</DropdownMenu.Content>
	</DropdownMenu.Root>
</div>

<style>
	:global(.language-item) {
		transition: background-color 0.2s ease;
	}
	:global(.language-item:hover) {
		background-color: #3a1b50 !important;
	}
</style>
